export const en = {
  brand: {
    name: "Human, Mostly",
    tagline: "Psychology, relationships & the messy art of living.",
  },
  nav: {
    bookstore: "Bookstore",
    lessons: "Lessons",
    map: "Map",
    archetype: "Archetype",
    letters: "Letters",
    about: "About",
    profile: "Profile",
    cart: "Cart",
    unreadLetters: "Letters, unread: {count}",
    toggleMenu: "Toggle menu",
  },
  routes: {
    about: "/about",
    auth: "/auth",
    profile: "/profile",
    terms: "/terms",
    privacy: "/privacy",
    thankYou: "/thank-you",
    install: "/install",
    letters: "/letters",
    inbox: "/letters",
    map: "/map",
    mapSolo: "/map/solo",
    mapCareer: "/map/career",
    mapFill: "/map/fill",
    couplesMap: "/couples-map",
    couplesCode: "/couples-map/code",
    couplesFill: "/couples-map/fill",
    archetype: "/archetype",
    archetypeDetails: "/archetype/details",
    unsubscribe: "/unsubscribe",
    acceptInvitation: "/accept-invitation",
    giftReceived: "/gift-received",
  },
  footer: {
    links: "Links",
    contact: "Contact",
    letters: "Letters",
    rights: "All rights reserved",
    terms: "Terms",
    privacy: "Privacy",
    top: "Back to top",
  },
  home: {
    title: "Human, Mostly | Archetype Test and Maps",
    description: "Human, Mostly — the free Archetype Test, the SOLO Map and the Couples Map. Documents written in your own words.",
    ogTitle: "Human, Mostly",
    ogDescription: "The free Archetype Test, the SOLO Map and the Couples Map.",
  },
  intlHome: {
    eyebrow: "Human, Mostly",
    headline: "A quiet system for understanding yourself.",
    body: "Take the free Archetype Test, build a SOLO Map in your own words, or create a Couples Map for the conversation you keep postponing.",
    primary: "Take the test",
    secondary: "Explore the maps",
    values: ["Free archetype test", "SOLO Map", "Couples Map", "Letters"],
    mapEyebrow: "The Maps",
    mapHeadline: "Not tests. Documents written from your own words.",
    soloTitle: "SOLO Map",
    soloBody: "A six-chapter portrait about where you are, what brought you here, and what wants to change.",
    couplesTitle: "Couples Map",
    couplesBody: "Two separate questionnaires, one shared map, and questions for the conversation afterwards.",
    manifestoEyebrow: "What we believe",
    manifesto: "Real happiness begins when you can look at your life without performing it.",
    newsletterEyebrow: "Letters",
    newsletterTitle: "Stay close to the work.",
    newsletterBody: "Occasional notes, new letters and openings from Rimantė.",
  },
  newsletter: {
    emailPlaceholder: "your email",
    submit: "Subscribe",
    invalidEmpty: "Enter your email address",
    invalidFormat: "The email format is not valid",
    invalidLong: "The email address is too long",
    spamNote: "Check your spam folder if you don't see the email.",
    tooMany: "Too many requests. Please wait a minute.",
    genericError: "Something went wrong. Please try again.",
    pageTitle: "Letters | Human, Mostly",
    pageDescription: "A weekly letter from Rimantė. €5 per month.",
    h1: "Letters",
    intro: "Once a week, Rimantė writes a letter. Not an article, not advice. A letter about what she is trying to understand that week.",
    archive: "Letters",
    read: "Read",
    readStart: "Read the beginning",
    allLetters: "All letters",
    notFoundTitle: "This letter does not exist",
    notFoundBody: "The link may have changed. You can find all letters in the archive.",
    paywallTitle: "The rest is for subscribers",
    paywallBody: "Subscribers read the full letter. Once a week, Rimantė writes to you.",
    subscribeCta: "Subscribe – €5 per month",
    cancelAnytime: "Cancel anytime.",
  },
  common: {
    loading: "Loading...",
    comingSoon: "Coming soon",
  },
} as const;
